/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/


export enum ContextMenuTypeEnum {
    EMPTY = 'Empty',
    PATH_POOL = 'Path_Pool',
    PATH_CONNECTIONS_POOL = 'Path_Connections_Pool',
    CONNECTIONS_POOL = 'Connections_Pool'
}
